// extracted by mini-css-extract-plugin
export default {"deviderContainer":"Devider_deviderContainer__1geF9","devider":"Devider_devider__WpisV"};